import { render, staticRenderFns } from "./EditarEventos.vue?vue&type=template&id=15d8e47a"
import script from "./EditarEventos.vue?vue&type=script&lang=js"
export * from "./EditarEventos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15d8e47a')) {
      api.createRecord('15d8e47a', component.options)
    } else {
      api.reload('15d8e47a', component.options)
    }
    module.hot.accept("./EditarEventos.vue?vue&type=template&id=15d8e47a", function () {
      api.rerender('15d8e47a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizacion/series-documentales/EditarEventos.vue"
export default component.exports